import React from 'react';
import { connect } from "react-redux";
import bindAll from 'lodash.bindall';
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import { getGuide } from "../../api/guide";
import { getLessonMembers } from "../../api/lesson";
import {
    doneCreatingProject,
    doneUpdatingProject,
    LoadingState,
    LoadingStates,
    manualUpdateProject,
    onLoadedProject,
    reloadProject,
    saveProjectAsCopy,
    setProjectId,
    setProjectIdSilent
} from '../../../reducers/project-state';
import WrappedGui from "../wrapped-gui/wrapped-gui";
import { setPlayer } from "../../..";
import { setEditMode, setTeachMode, setChatBox } from "../../reducers/teach";
import qs from "qs";
import { GUIDE_MODE, TASK_PROGRESS_DOING, TASK_PROGRESS_DONE, TRAIN_MODE, EXAMPLE_MODE, ZINDEX_SYSTEM_BTN } from "../../lib/constant";
import LoaderComponent from "../../../components/loader/loader";
import event, { EVENTS } from "../../lib/event";
import { headNavBack } from "../../lib/utils";
import { saveTaskRecord } from "../../api/task-record";
import { getProjectInfo } from "../../api/project";
import ModalManager from "../modal/modal-manager";
import SaveStatus from '../../../components/menu-bar/save-status';
import TaskDescModal from '../../pages/lesson/task-desc-modal';
import UpdateGuideModal from './updateGuide-modal';
import TaskProgressBar from '../task-progress-bar';
import { BUTTONS } from '../../guide/steps-runtime';
import saveProjectToServer from '../../../lib/save-project-to-server';
import Studentsgrades from "../confirm-modal/students-grades";
import styles from './styles.scss';
import down from './down.png';

class TaskGuide extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleLoadedProject',
            'handleUpdatedProject',
            'handleUpdateProjectError',
            'handleCreatedProject',
            'handleSwitchToNextStep',
            'handleNavBack',
            'handleSwitchTask',
            'handleShowAnswer',
            'handleBackToStudy',
            'restudyTask',
            'taskFinish',
            'loadInitProject',
            'loadModifiedProject',
            'save',
            'saveProjectToServer',
            'saveProjectToModifiedProject',
            'currentTask',
            'handleExitGuide',
            'handleCorrect'
        ]);
        this.query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
        props.setEditMode(!!this.query.isEditMode);
        props.setPlayer(false); //确保为非Player模式
        this.state = {
            guide: undefined,
            loadfinish: false
        };
        this.key = this.randomString();
        // props.setChatBox(true);

    }
    randomString(len) {
        len = len || 32;
        var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
        var maxPos = $chars.length;
        var pwd = '';
        for (let i = 0; i < len; i++) {
            pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    }
    componentDidMount() {
        event.on(EVENTS.RESTUDY_TASK, this.restudyTask);
        event.on(EVENTS.STEP_SWITCHED_STEP, this.handleSwitchToNextStep); //每进入下一步，保存改编的项目
        event.on(EVENTS.STEP_GUIDE_FINISH, this.taskFinish);
        event.on(EVENTS.TASK_LOAD_INIT_PROJECT, this.loadInitProject);
        event.on(EVENTS.TASK_LOAD_MODIFIED_PROJECT, this.loadModifiedProject);
        event.on(EVENTS.TASK_SAVE_PROJECT_TO_MODIFIED_PROJECT, this.saveProjectToModifiedProject);
        event.on(EVENTS.NAV_BACK, this.handleNavBack);
        event.on(EVENTS.SHOW_ANSWER_MODE, this.handleShowAnswer);
        event.on(EVENTS.TASK_BACK_TO_STUDY, this.handleBackToStudy);
        event.on(EVENTS.STEP_EXIT_GUIDE_MODE, this.handleExitGuide);
        event.on(EVENTS.PROJECT_LOADED_FINISH, () => this.setState({ loadfinish: true }));
        event.on(EVENTS.UPDATE_PROJECT_ERROR, this.handleUpdateProjectError);
        event.on(EVENTS.TASK_SAVE, this.save);

        this.props.setChatBox(true)

        window.stepsRuntime.reset();
        getGuide({ id: this.props.task.guide_id })
            .then(res => {
                if (res.steps) {
                    res.steps = JSON.parse(res.steps);
                }
                if (res.steps[0].manifest) {
                    if (res.steps[0].finish) {
                        res.done_project_id = res.steps[0].finish;
                    }
                    if (res.steps.length > 1 && res.steps[0].init !== undefined && res.steps[1].init === undefined) {
                        res.steps[1].init = res.steps[0].init;
                    }
                    if (res.steps[0].desc) {
                        this.props.task.desc = res.steps[0].desc;
                    }
                    res.steps.shift(); //删除第一个元素
                }
                if (res.steps[0].init === undefined) {
                    res.steps = [{
                        step: '兼容旧版本引导',
                        tips: '接下来，小奥将手把手引导你完成这个作品。请点击下面的按钮，开始学习。',
                        init: res.project_id,
                        finish: res.done_project_id,
                        mode: 1, //自动进入引导模式
                        actions: res.steps
                    }];
                } else {
                    res.project_id = res.steps[0].init; //兼容旧代码
                }
                res.steps[0].guideId = window.stepsRuntime.guideId = this.props.task.guide_id;
                this.setState({ ...this.state, guide: res }, () => {
                    //首次加载项目，开始引导步骤
                    if (this.state.guide && this.state.guide.steps && this.state.guide.steps.length > 0) {
                        let runtimeState;
                        if (this.props.task.record.runtime) {
                            runtimeState = JSON.parse(this.props.task.record.runtime);
                            if (!runtimeState.guideId) runtimeState.guideId = this.props.task.guide_id;
                        }
                        if (this.props.isCheck) { //作业批改模式
                            if (runtimeState) {
                                this.restoreRuntimeState(runtimeState); //恢复到孩子学习结束的状态
                            } else {
                                showMessage('改学生没有作业提交记录');
                            }
                        } else {
                            if (runtimeState && runtimeState.chatSteps && runtimeState.chatSteps.length > 0) { //有历史状态，载入历史状态
                                if (runtimeState.steps && runtimeState.steps.length > 0 && runtimeState.steps[0].version == this.state.guide.steps[0].version) {
                                    runtimeState.steps = this.state.guide.steps; //载入最新版本的引导步骤，风险是可能发生变化与当前聊天记录无法匹配
                                    this.restoreRuntimeState(runtimeState);
                                } else {
                                    ModalManager.open(UpdateGuideModal, {
                                        closeAfterSubmit: true,
                                        onClose: () => {
                                            this.restoreRuntimeState(runtimeState); //使用旧的引导脚本继续学习
                                        },
                                        content: "课程引导脚本有更新，是否更新到最新版本重新学习？",
                                        onConfirm: () => {
                                            this.restudyTask(); //切换到新到脚本，重新学习
                                            ModalManager.pop();
                                        }
                                    });
                                }

                            } else {
                                window.stepsRuntime.run(this.state.guide.steps);
                                //打开任务描述
                                ModalManager.open(TaskDescModal, {
                                    closeAfterSubmit: true,
                                    onClose: () => {
                                    },
                                    task: this.currentTask(),
                                    onConfirm: () => {
                                        ModalManager.pop();
                                    },
                                    type: 'new',
                                    homework: this.state.guide.done_project_id ? 1 : 0
                                });
                            }
                        }
                    } else {
                        showMessage('该课程缺少引导步骤！');
                    }
                });
            });
    }


    componentWillUnmount() {
        event.off(EVENTS.RESTUDY_TASK, this.restudyTask);
        event.off(EVENTS.STEP_SWITCHED_STEP, this.handleSwitchToNextStep);
        event.off(EVENTS.STEP_GUIDE_FINISH, this.taskFinish);
        event.off(EVENTS.TASK_LOAD_INIT_PROJECT, this.loadInitProject);
        event.off(EVENTS.TASK_LOAD_MODIFIED_PROJECT, this.loadModifiedProject);
        event.off(EVENTS.TASK_SAVE_PROJECT_TO_MODIFIED_PROJECT, this.saveProjectToModifiedProject);
        event.off(EVENTS.NAV_BACK, this.handleNavBack);
        event.off(EVENTS.SHOW_ANSWER_MODE, this.handleShowAnswer);
        event.off(EVENTS.TASK_BACK_TO_STUDY, this.handleBackToStudy);
        event.off(EVENTS.STEP_EXIT_GUIDE_MODE, this.handleExitGuide);
        event.off(EVENTS.PROJECT_LOADED_FINISH, () => this.setState({ loadfinish: true }));
        event.off(EVENTS.UPDATE_PROJECT_ERROR, this.handleUpdateProjectError);
        event.off(EVENTS.TASK_SAVE, this.save);
        window.stepsRuntime.reset();
        ModalManager.closeAll();
        this.props.setChatBox(false);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { task } = this.props;
        //载入项目出错，恢复到最初始的项目
        if (this.props.loadingState == LoadingState.ERROR) {
            console.error('载入项目出错，恢复到初始项目：' + this.props.task.record.modified_project_id + ' ' + this.props.projectId);
            this.props.task.record.modified_project_id = 0;
            saveTaskRecord(this.props.task.record, { quiet: true });
            let projectId = this.state.guide.project_id.toString();
            if (window.stepsRuntime.isStarted() && window.stepsRuntime.steps[window.stepsRuntime.stepIndex].init !== undefined) {
                projectId = window.stepsRuntime.steps[window.stepsRuntime.stepIndex].init.toString();
            }
            if (!this.loadingStateErrorCount) {
                this.loadingStateErrorCount = 1;
            } else {
                ++this.loadingStateErrorCount;
            }
            if (this.loadingStateErrorCount < 3) {
                this.props.setProjectId(projectId);
            } else {
                console.error('载入项目出错超过3次');
            }
        }
    }

    /**
     * 恢复运行时状态
     * @param runtimeState
     */
    restoreRuntimeState(runtimeState) {
        window.stepsRuntime.restoreState(runtimeState);
        if (!this.props.isCheck) {
            ModalManager.open(TaskDescModal, {
                closeAfterSubmit: true,
                onClose: () => { //继续学习
                },
                task: this.currentTask(),
                onConfirm: () => {
                    ModalManager.pop();
                },
                onRestudy: () => {
                    event.emit(EVENTS.RESTUDY_TASK);
                    ModalManager.closeAll();
                },
                type: 'history',
                onAnswer: () => {
                    event.emit(EVENTS.SHOW_ANSWER_MODE);
                    ModalManager.pop();
                }
            });
        }
    }

    handleShowAnswer() {
        event.emit(EVENTS.CLEAR_COVER);
        event.once(EVENTS.TASK_GUIDE_PROJECT_SAVED, () => {
            stepsRuntime.showButtons([BUTTONS.BACK_TO_STUDY]);
            this.loadFinishProject();
        });
        this.save();
    }

    handleBackToStudy() {
        stepsRuntime.resume();
    }

    currentTask() {
        const { currentLesson } = this.props
        if (currentLesson.tasks.length == 0)
            return null;
        else if (currentLesson.record)
            return currentLesson.tasks[currentLesson.record.current_task];
        else
            return currentLesson.tasks[0];
    }

    //重新学习
    restudyTask() {
        window.stepsRuntime.reset();
        this.props.task.record.runtime = undefined;
        this.saveRuntimeState();
        window.stepsRuntime.run(this.state.guide.steps);
    }

    //运行到下一个步骤，保存状态
    handleSwitchToNextStep() {
        //this.save();
    }

    taskFinish() {
        this.save();
        this.props.task.record.progress = TASK_PROGRESS_DONE;
        this.props.onTaskUpdate();
    }

    /**
     * 载入某个step的手把手引导的初始项目
     * @param projectId
     */
    loadInitProject(projectId) {
        if (this.props.task.record.modified_project_id && this.props.task.record.modified_project_id == this.props.projectId && this.props.projectChanged) { //当前处于改编的项目中，并且项目已经被修改
            event.once(EVENTS.TASK_GUIDE_PROJECT_SAVED, () => {
                this.props.setProjectId(projectId.toString());
            })
            this.props.saveProject();
        } else {
            if (projectId == 0 && this.props.projectId == projectId) { //初始化项目是0
                this.props.reloadProject();
            } else { //正常切换载入项目
                this.props.setProjectId(projectId.toString());
            }
        }
    }

    /**
     * 载入完成后到标准工程
     */
    loadFinishProject() {
        const projectId = this.state.guide.done_project_id;
        if (projectId != undefined) {
            this.props.setProjectId(projectId.toString());
        }
    }

    /**
     * 载入用户改编过的项目，如果不存在，默认载入初始项目
     */
    loadModifiedProject() {
        const projectId = this.props.task.record.modified_project_id || this.state.guide.project_id;
        if (projectId) {
            getProjectInfo({ id: projectId }).then(r => {
                this.props.setProjectId(projectId.toString());
            }, e => { //项目被删除的情况
                if (e.code === -1) {
                    console.error('项目被删除：' + projectId);
                    this.props.task.record.modified_project_id = 0;
                    saveTaskRecord(this.props.task.record, { quiet: true });
                    this.props.setProjectId(this.state.guide.project_id.toString());
                    stepsRuntime.modifiedProjectId = this.state.guide.project_id.toString();
                }
            });
        } else { //不存在改编过的项目，并且初始化项目是0
            this.props.setProjectId('0');
            stepsRuntime.modifiedProjectId = '0';
        }
    }

    /**
     * 如果当前是改编后的项目，保存之
     * 如果当前是引导中的项目，不会自动当前Step的中间状态
     */
    save() {
        //console.error('modified ' + this.props.task.record.modified_project_id + ' ' + this.props.projectId);
        if (this.props.task.record.modified_project_id == this.props.projectId) { //如果当前就是改编的项目，触发保存
            if (this.props.projectChanged) {
                this.props.saveProject(); //项目保存后会自动触发RuntimeState的保存
            } else {
                this.saveRuntimeState(); //触发保存聊天记录等相关状态
                event.emit(EVENTS.TASK_GUIDE_PROJECT_SAVED); //触发保存成功的监听
            }
        } else { //当前为非改编项目，保存到改编项目中
            this.saveProjectToModifiedProject();
        }
    }

    /**
     * 将当前项目覆盖到用户改编过的项目中
     */
    saveProjectToModifiedProject() {
        //console.error('save to modified ' + this.props.task.record.modified_project_id + ' ' + this.props.projectId);
        if (this.props.task.record.modified_project_id) {
            this.props.setProjectIdSilent(this.props.task.record.modified_project_id.toString());
            this.props.saveProject();
        } else {
            this.props.saveProjectAsCopy();
        }
    }

    saveRuntimeState() {
        //保存stepsRuntime的状态
        this.props.task.record.runtime = window.stepsRuntime.dumpState();
        saveTaskRecord(this.props.task.record, { quiet: true }).finally(() => {
            console.log('saved task record');
            if (this.isNavBackCalled) {
                this.isNavBackCalled = false;
                //这里执行真正的返回
                headNavBack(this.props.history);
            }
            if (this.isSwitchTaskCalled) {
                this.props.onSelect(this.switchTaskItem, this.switchTaskIndex);
            }
        });
    }

    /**
     * GUI的项目保存回调
     */
    saveProjectToServer(projectId, vmState, params) {
        /*
        if (stepsRuntime.mode === GUIDE_MODE) { //引导模式下将项目状态保存到stepsRuntime中
            window.stepsRuntime.vmState = vmState;
            return {status: 'ok', 'result-code': 0, 'content-name': 0 + projectId, id: 0 + projectId};
        }else { //正常保存项目
            return saveProjectToServer(projectId, vmState, params);
        }*/
        return saveProjectToServer(projectId, vmState, params);
    }

    handleLoadedProject(loadingState, canSave) {
        this.props.onLoadedProject(loadingState, canSave, true);
    }

    /**
     * 项目被保存时触发
     * @param loadingState
     */
    handleUpdatedProject(loadingState) {
        this.props.onUpdatedProject(loadingState);
        //console.error('update ' + this.props.task.record.modified_project_id + ' ' + this.props.projectId);
        this.props.task.record.modified_project_id = this.props.projectId;
        this.saveRuntimeState(); //项目保存时，同步保存引导状态
        event.emit(EVENTS.TASK_GUIDE_PROJECT_SAVED);
    }

    /**
     * 保存项目失败
     */
    handleUpdateProjectError(err) {
        console.error(err);
        if (err === 403) { //没有权限时，保存为副本
            this.props.saveProjectAsCopy();
        }
    }

    /**
     * 创建副本时触发
     * @param projectId
     * @param loadingState
     */
    handleCreatedProject(projectId, loadingState) {
        this.props.onCreatedProject(projectId, loadingState);
        //console.error('create ' + this.props.task.record.modified_project_id + ' ' + this.props.projectId);
        this.props.task.record.modified_project_id = projectId;
        this.saveRuntimeState(); //项目保存时，同步保存引导状态
        event.emit(EVENTS.TASK_GUIDE_PROJECT_SAVED);
    }

    /**
     * 退出课程按钮被点击
     */
    handleNavBack() {
        this.isNavBackCalled = true;
        //先提示结束引导模式
        if (stepsRuntime.mode === GUIDE_MODE) {
            //stepsRuntime.handleExitGuideMode(); //退出引导后会触发save，进而触发任务切换
            this.save(); //不提示退出引导模式，直接保存
        } else {
            this.save(); //保存并退出课程
        }
    }

    /**
     * 任务切换
     * @param item
     * @param index
     */
    handleSwitchTask(item, index) {
        this.isSwitchTaskCalled = true;
        this.switchTaskItem = item;
        this.switchTaskIndex = index;
        //先提示结束引导模式
        if (stepsRuntime.mode === GUIDE_MODE) {
            //stepsRuntime.handleExitGuideMode(); //退出引导后会触发save，进而触发任务切换
            this.save(); //不提示退出引导，直接保存退出
        } else {
            this.save(); //保存并切换任务
        }
    }

    handleExitGuide() {
        if (stepsRuntime.mode === GUIDE_MODE) {
            stepsRuntime.handleExitGuideMode();
        }
    }

    // 切换学生
    async handleCorrect(lesson) {
        const ids = {
            clazzId: this.query.clazz_id,
            courseId: this.query.course_id,
            history: this.props.history
        }
        let members = await getLessonMembers({
            clazz_id: this.query.clazz_id,
            course_id: this.query.course_id,
            id: lesson.id,
        }, { quiet: true });
        ModalManager.open(Studentsgrades, {
            msg: members,
            closeAfterSubmit: true,
            lesson: lesson,
            ids: ids,
            onClose: () => { }
        });
    }

    render() {
        const { stepMode, currentTaskId, homeworkBeginTask, lessonProgress, currentLesson, onRate, isCheck, currentMember, isPhone } = this.props
        //return (this.props.projectId ? (<WrappedGui projectId={this.props.projectId}/>) : <Loading/>);
        let fraction = null
        if (currentLesson.record && currentLesson.record.rate) {
            if (currentLesson.record.rate == '1') {
                fraction = '未通过'
            }
            if (currentLesson.record.rate == '3') {
                fraction = 'D'
            }
            if (currentLesson.record.rate == '6') {
                fraction = 'C'
            }
            if (currentLesson.record.rate == '8') {
                fraction = 'B'
            }
            if (currentLesson.record.rate == '10') {
                fraction = 'A'
            }
        }
        return (this.state.guide ? (<div>
            <div
                id={this.state.guide}
                style={{
                    height: 44,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'absolute',
                    paddingLeft: isPhone ? 120 : 20,
                    left: '50%',
                    top: 0,
                    transform: 'translateX(-40%)',
                    zIndex: ZINDEX_SYSTEM_BTN
                }}
            >
                {
                    isCheck &&
                    <div onClick={() => this.handleCorrect(currentLesson)} className={styles.member}>
                        <span>{currentMember}</span>
                        <img src={down}></img>
                    </div>
                }
                <TaskProgressBar
                    currentTaskId={currentTaskId}
                    homeworkBeginTask={homeworkBeginTask}
                    lessonProgress={lessonProgress}
                    onSelect={this.handleSwitchTask}
                />
                {
                    isCheck &&
                    <div onClick={onRate} className={styles.rateBtn}>
                        <span>
                            {fraction ? `评分${fraction}` : window.L('teach.lesson.unCommented')}
                        </span>
                    </div>
                }
                {
                    !isCheck && currentLesson.record && currentLesson.record.rate &&
                    <div className={styles.rateBtn} onClick={onRate}>
                        <span>
                            {fraction ? `评分${fraction}` : window.L('teach.lesson.unCommented')}
                        </span>
                    </div>
                }
                {
                    stepMode === TRAIN_MODE && this.state.loadfinish &&
                    <div>
                        <SaveStatus isInTask={lessonProgress.length > 0 ? true : false} />
                    </div>
                }
            </div>
            <WrappedGui
                //projectId={this.props.projectId}
                canSave={this.props.task && this.props.task.record && this.props.task.record.modified_project_id && this.props.task.record.modified_project_id == this.props.projectId} //{this.state.guide && this.state.guide.project_id != this.props.projectId && this.state.guide.done_project_id != this.props.projectId} //引导模式下不允许保存，但是如果保存为副本后可以支持保存
                autoSave={this.props.task && this.props.task.record && this.props.task.record.modified_project_id && this.props.task.record.modified_project_id == this.props.projectId}
                onUpdateProjectData={this.saveProjectToServer}
                enableCommunity={false}
                canShare={false}
                onLoadedProject={this.handleLoadedProject}
                onUpdatedProject={this.handleUpdatedProject}
                onCreatedProject={this.handleCreatedProject}
                isProgramTask={1}
                chatBox={true}
                backpackVisible={false}
            />
        </div>
        ) : (<LoaderComponent message={window.L('teach.loading')} />));
    }
}

TaskGuide.propTypes = {
    task: PropTypes.object,
    onTaskUpdate: PropTypes.func,
    setProjectId: PropTypes.func,
    reloadProject: PropTypes.func,
    projectId: PropTypes.string,
    isEditMode: PropTypes.bool,
    teachMode: PropTypes.number,
    onLoadedProject: PropTypes.func,
    onUpdatedProject: PropTypes.func,
    onCreatedProject: PropTypes.func,
    setPlayer: PropTypes.func,
    setEditMode: PropTypes.func,
    setTeachMode: PropTypes.func,
    isCheck: PropTypes.bool,
    saveProject: PropTypes.func,
    saveProjectAsCopy: PropTypes.func,
    projectChanged: PropTypes.bool,
    loadingState: PropTypes.oneOf(LoadingStates),
    setProjectIdSilent: PropTypes.func,
    onSelect: PropTypes.func,
    isChatBox: PropTypes.bool,
    setChatBox: PropTypes.func,
    stepMode: PropTypes.bool,
}

const mapStateToProps = state => ({
    projectId: state.scratchGui.projectState.projectId,
    isEditMode: state.teach.isEditMode,
    teachMode: state.teach.teachMode,
    projectChanged: state.scratchGui.projectChanged,
    loadingState: state.scratchGui.projectState.loadingState,
    isChatBox: state.teach.isChatBox,
    stepMode: state.teach.stepMode,
    isPhone: state.teach.isPhone
});

const mapDispatchToProps = dispatch => ({
    setProjectId: projectId => dispatch(setProjectId(projectId)),
    setProjectIdSilent: projectId => dispatch(setProjectIdSilent(projectId)),
    reloadProject: () => dispatch(reloadProject()),
    onLoadedProject: (loadingState, canSave, success) => dispatch(onLoadedProject(loadingState, canSave, success)),
    onUpdatedProject: loadingState => dispatch(doneUpdatingProject(loadingState)),
    onCreatedProject: (projectId, loadingState) => dispatch(doneCreatingProject(projectId, loadingState)),
    setPlayer: isPlayerOnly => dispatch(setPlayer(isPlayerOnly)),
    setEditMode: isEditMode => dispatch(setEditMode(isEditMode)),
    setTeachMode: mode => dispatch(setTeachMode(mode)),
    saveProject: () => dispatch(manualUpdateProject()),
    saveProjectAsCopy: () => dispatch(saveProjectAsCopy()),
    setChatBox: isChatBox => dispatch(setChatBox(isChatBox)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TaskGuide));
